<template>
  <v-container fluid>
    <v-row class="">
      <v-col cols="12" md="6">
        <h3>My Profile</h3>
        <v-divider class="mt-1 mb-3"/>
        <v-text-field outlined dense v-model="$store.state.user.name" disabled label="Name"/>
        <v-text-field outlined dense v-model="$store.state.user.email" disabled label="Email"/>
        <v-text-field outlined dense v-model="$store.state.user.phone" label="Phone"/>
        <v-text-field outlined dense v-model="$store.state.user.idnumber" disabled label="ID number"/>
        <v-btn outlined class="" @click="requestPasswordOtP">Update Details</v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn outlined class="" @click="requestPasswordOtP">Request OTP</v-btn>
        <v-form ref="=form">
          <v-text-field
              label="Enter Your OTP"
              outlined
              clearable
              dense
              :rules="notEmpty"
              v-model="userForm.code"
              color="blue"
              :autocomplete="false"
              class="mt-16"
          />
          <v-text-field
              dense
              v-model="userForm.password"
              label="Enter Your new Password"
              type="password"
              placeholder="mysecretpassword"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="notEmpty"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              clearable
              :autocomplete="false"
              required
              outlined
              class="ma-1"
          />
          <v-text-field
              dense
              v-model="userForm.cpassword"
              label="Confirm Your New Password"
              type="password"
              placeholder="mysecretpassword"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="notEmpty"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              clearable
              :autocomplete="false"
              required
              outlined
              class="ma-1"
          />
          <v-btn color="blue" class="mt-2 " dark block tile @click="forgotPassword">Change Password
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChangePassword",
  data() {
    return {
      show: false,
      show1: false,
      loading: false,
      userForm: new Form({
        code: "",
        password: "",
        cpassword: "",
      }),
      notEmpty: [
        v => !!v || 'Field is required',
      ],
    }
  },
  methods: {
    requestPasswordOtP() {
    },
    forgotPassword() {
    }
  }
}
</script>

<style scoped>

</style>